export default "__VITE_ASSET__DxrXlQGQ__"